export const translation = {
  // Navigation
  nav: {
    home: 'Home',
    categories: 'Categories',
    guides: 'Guides',
    shoppingGuide: 'Shopping Guide',
    about: 'About',
    contact: 'Contact',
    searchPlaceholder: 'Search products, categories, guides...',
  },

  // Language selector
  lang: {
    en: 'English',
    pt: 'Português',
    de: 'Deutsch',
    current: 'English',
  },

  // Hero Section
  hero: {
    eyebrow: 'CSSBuy Spreadsheet • Independent Guide • Updated',
    h1: 'CSSBuy Spreadsheet: Find, Compare and Research Products with More Confidence',
    subtitle: 'Explore an independent CSSBuy Spreadsheet resource with organized lists, categories, buying guides, QC information, warehousing, shipping and safety — all in one place.',
    ctaPrimary: 'Explore CSSBuy Spreadsheet',
    ctaSecondary: 'Visit Main Website',
  },

  // Categories Section
  categories: {
    h2: 'Explore CSSBuy Spreadsheet by Category',
    subtitle: 'Browse our organized product categories and find the resources you need for your next purchase.',
    viewAll: 'View All Categories',
    items: {
      shoes: 'Shoes',
      hoodies: 'Hoodies/Sweaters',
      tshirts: 'T-Shirts',
      jackets: 'Jackets',
      pants: 'Pants/Shorts',
      headwear: 'Headwear',
      sets: 'Sets',
      underwear: 'Underwear/Underpants',
      jersey: 'Jersey',
      accessories: 'Accessories',
      bags: 'Bags',
      belts: 'Belts',
      perfumes: 'Perfumes',
      other: 'Other Stuff',
    },
  },

  // Products Section
  products: {
    title: 'Featured Products from Kakobuy Spreadsheet',
    subtitle: 'Browse our curated collection of verified products. Click any item to view details and purchase on the main site.',
    viewAll: 'View All in {{category}}',
    buyNow: 'Buy Now',
  },

  // Dropdown
  dropdown: {
    label: 'Select Category',
    placeholder: 'Choose a product category...',
  },

  // Main CTA Buttons
  cta: {
    cssbuySpreadsheet: 'CSSBuy Spreadsheet',
    buyItNow: 'Buy It Now',
  },

  // Guide Section
  guide: {
    h2: 'Start with Our CSSBuy Spreadsheet Guide',
    text: 'Learn how to research products, compare options and understand QC, warehousing and shipping information in a more organized way.',
    cta: 'Read Full Guide',
  },

  // Review Section
  review: {
    h2: 'CSSBuy Review: What You Should Know',
    text: 'Consult our independent review about the buying process, QC, warehousing, shipping, costs and important points for new users.',
    cta: 'Read CSSBuy Review',
  },

  // Shipping Section
  shipping: {
    h2: 'CSSBuy Shipping Cost: Understand What Affects the Price',
    text: 'International shipping costs vary by destination, weight, volume, shipping method, packaging and other conditions. Learn how to research costs before shipping your package.',
    cta: 'View Shipping Cost Guide',
  },

  // Trust section
  trust: {
    tag1: 'Independent Resource',
    tag2: 'Multilingual Guides',
    tag3: 'Organized Research',
    tag4: 'Updated Content',
  },

  // FAQ
  faq: {
    h2: 'Frequently Asked Questions',
    q1: 'What is CSSBuy Spreadsheet?',
    a1: 'An organized resource for researching and comparing products, categories and information related to the buying process.',
    q2: 'Is CSSBuy Spreadsheet official?',
    a2: 'No. This website is an independent resource and is not operated, sponsored or endorsed by CSSBuy.',
    q3: 'Is CSSBuy legit?',
    a3: 'Consult our independent guide about legitimacy, safety, payments, QC and shipping.',
    q4: 'How much does CSSBuy shipping cost?',
    a4: 'The cost depends on destination, weight, volume, route and package characteristics.',
    q5: 'Where can I find CSSBuy Spreadsheet?',
    a5: 'Use our directory organized by categories and guides.',
  },

  // Final CTA
  finalCta: {
    h2: 'Ready to Research Smarter?',
    text: 'Explore the CSSBuy Spreadsheet, compare information and find the right guides for your next research.',
    ctaPrimary: 'Explore CSSBuy Spreadsheet',
    ctaSecondary: 'Visit Main Website',
  },

  // Footer
  footer: {
    disclaimer: 'CSSBuy Spreadsheet is an independent informational resource and is not affiliated with, endorsed by, or operated by CSSBuy.',
    nav: {
      spreadsheet: 'CSSBuy Spreadsheet',
      guide: 'Spreadsheet Guide',
      list: 'Spreadsheet List',
      finds: 'Spreadsheet Finds',
      review: 'Review',
      shipping: 'Shipping',
      qc: 'QC',
      warehouse: 'Warehouse',
      safety: 'Safety',
      faq: 'FAQ',
      blog: 'Blog',
      editorial: 'Editorial Policy',
      about: 'About',
      contact: 'Contact',
      privacy: 'Privacy',
      terms: 'Terms',
      disclaimer: 'Disclaimer',
    },
  },

  // SEO / Page titles
  seo: {
    homeTitle: 'CSSBuy Spreadsheet | Independent Resource Hub & Research Guide',
    homeDesc: 'Independent CSSBuy Spreadsheet resource with organized product categories, buying guides, reviews, shipping costs, QC info and safety tips.',
  },

  // Blog / Articles
  blog: {
    h2: 'Latest CSSBuy Spreadsheet Guides',
    subtitle: 'Explore our pillar guides covering product research, reviews, shipping, QC, warehouse, safety and more.',
    readMore: 'Read Article',
    updatedLabel: 'Last updated',
    backHome: 'Back to Home',
    relatedTitle: 'Related Guides',
    article1: {
      title: 'CSSBuy Spreadsheet 2026: Complete Guide to Product Research',
      excerpt: 'Learn how to use CSSBuy Spreadsheet for organized product research, category comparison, and informed buying decisions.',
      date: 'August 2026',
    },
  },

  // General
  general: {
    independentNotice: 'Independent Resource — Not affiliated with CSSBuy.',
  },
};

export default translation;